/**
 * The "Chat / Messenger aktivieren?" choice in Systemkonfiguration (Hans, ticket 2610004).
 *
 * UI-only: it is never stored. Firestore holds the two booleans `enablePersonalChat` and
 * `enableProjectChat`, which is what the apps read; this enum only lets Office show the pair as the
 * single four-option picker Hans asked for.
 */
export enum ChatMode {
  NONE = "NONE",
  PERSONAL_ONLY = "PERSONAL_ONLY",
  PROJECT_ONLY = "PROJECT_ONLY",
  BOTH = "BOTH",
}

/** The picker's options, in the order Hans listed them. */
export const CHAT_MODE_VALUES = [
  ChatMode.NONE,
  ChatMode.PERSONAL_ONLY,
  ChatMode.PROJECT_ONLY,
  ChatMode.BOTH,
];

/** The two stored flags a {@link ChatMode} stands for. */
export interface ChatFlags {
  enablePersonalChat: boolean;
  enableProjectChat: boolean;
}

/**
 * Reads the stored flags as one picker choice. Every combination maps to exactly one mode, so a
 * document written by any source still shows a valid selection.
 */
export function chatModeFromFlags(enablePersonalChat: boolean, enableProjectChat: boolean): ChatMode {
  if (enablePersonalChat && enableProjectChat) {
    return ChatMode.BOTH;
  }

  if (enablePersonalChat) {
    return ChatMode.PERSONAL_ONLY;
  }

  return enableProjectChat ? ChatMode.PROJECT_ONLY : ChatMode.NONE;
}

/** The stored flags for a picker choice. */
export function chatFlagsFromMode(mode: ChatMode): ChatFlags {
  return {
    enablePersonalChat: mode === ChatMode.PERSONAL_ONLY || mode === ChatMode.BOTH,
    enableProjectChat: mode === ChatMode.PROJECT_ONLY || mode === ChatMode.BOTH,
  };
}
